/*
auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import * as THREE from 'three'
import React, { useRef, forwardRef, useState } from 'react'
import { useFrame } from "react-three-fiber"
import { useGLTF } from '@react-three/drei/useGLTF'

export default function Model(props) {
  const group = useRef()
  let counter = 1
  let theta = 0
  const { nodes } = useGLTF('/model.glb')
  var loader = new THREE.CubeTextureLoader();
  loader.setCrossOrigin("");
  loader.setPath( 'https://threejs.org/examples/textures/cube/pisa/' );

  var textureCube = loader.load( [
    'px.png', 'nx.png',
    'py.png', 'ny.png',
    'pz.png', 'nz.png'
  ] );
  // useFrame(() => (group.current.rotation.x = group.current.rotation.y += 0.01));
  useFrame(() => {
    counter=counter+0.00005
    group.current.rotation.x = group.current.rotation.y += Math.sin((Math.PI/180)*counter);
    // group.current.rotation.x = group.current.rotation.y += (Math.PI/300);
    // group.current.rotation.x = group.current.rotation.y += 0.1 * Math.sin( theta * Math.PI / 360 );
})   ;
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[0, -2, 0]}>
      <mesh antialias="true" castShadow geometry={nodes.Path_1.geometry}>
        {/* <sphereGeometry args={[1, 16, 16]} /> */}
        {/* <meshStandardMaterial antialias="true" color="#c23b27" transparent opacity="1"/> */}
        {/* <meshStandardMaterial antialias="true" color="#c23b27"  */}
        <meshStandardMaterial antialias="true" color="orange" 
        metalness={1} roughness={0.5} envMap={textureCube} 
        // map="texture" combine={THREE.MixOperation} reflectivity={.5}
        // roughnessMap="roughnessMap" metalnessMap="metalnessMap"
        // envMap="envMap" envMapIntensity="envMapIntensity"
        transparent opacity="1"/>
        {/* <geometry args={nodes.Path_1.geometry} /> */}
      </mesh>
        {/* <mesh 
          material={materials.Mat} 
          geometry={nodes.Path_1.geometry} /> */}
      </group>
    </group>
  )
}

useGLTF.preload('/model.glb')
